import { Component } from '@angular/core';
import { environment } from 'src/environments/environments';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'XP-Tracking';
    constructor() {
    if (environment.production) {

      // Disable Right Click
      document.addEventListener('contextmenu', function (e) {
        e.preventDefault();
      });

      // Disable Inspect Shortcuts
      document.addEventListener('keydown', function (e) {
        if (
          e.key === 'F12' ||
          (e.ctrlKey && e.shiftKey && e.key === 'I') ||
          (e.ctrlKey && e.shiftKey && e.key === 'J') ||
          (e.ctrlKey && e.shiftKey && e.key === 'C') ||
          (e.ctrlKey && e.key === 'U')
        ) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }
  }

}
